module.exports = __webpack_public_path__ + "static/media/LoanCalculator2_14.ed7482bf.webp";